<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div style="width: 100%;height: 20px;"></div>
		<el-button type="primary" icon="el-icon-search" size="mini">查询</el-button>
		<router-link :to="{ name: 'cggl_ddcl_cgdd' }" class="ml-2"><el-button type="success" size="mini" icon="el-icon-truck">采购下单</el-button></router-link>
		<!-- 商品列表 -->
		<el-table class="mt-3" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" size="mini">
			<el-table-column type="selection" width="45" align="center">
			</el-table-column>
			<el-table-column align="center" prop="id" width="60" label="编号">
			</el-table-column>
			<el-table-column label="产品名称" width="140">
				<template slot-scope="scope">
					<div class="media"  style="display: flex;align-items: center;">
						{{scope.row.title}}
					</div>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="id" width="" label="产品编码">
			</el-table-column>
			<el-table-column align="center" prop="id" width="" label="条码">
			</el-table-column>
			<el-table-column align="center" prop="id" width="" label="计量单位">
			</el-table-column>
			<el-table-column align="center" prop="id" width="" label="预警库存">
			</el-table-column>
			<el-table-column align="center" width="120" label="产品分类">
				<template slot-scope="scope">
					<el-button type="success" size="mini" plain>大机械
					</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="120" label="产品类型">
				<template slot-scope="scope">
					<el-button type="info" size="mini" plain>大型商品
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="height: 60px;"></div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;">
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" layout="total, sizes, prev, pager, next, jumper"
				 :total="page.total" @size-change="handleSizeChange" @current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</el-footer>
		<el-dialog title="联系人" :visible.sync="createModel" top="10vh">
			<!-- 表单内容 -->
			<div style="width: 100%;margin-top: 20px;">
				<el-form :rules="rules" ref="form" :model="form" label-width="80px">
					<el-form-item label="信息编号" prop="name"><el-input v-model="form.id" size="mini" style="width: 100%;"></el-input></el-form-item>
					<el-form-item label="名称" prop="name"><el-input v-model="form.name" size="mini" style="width: 100%;"></el-input></el-form-item>
					<el-form-item label="客户名称" prop="name"><el-button type="success" size="mini">恒大集团</el-button></el-input></el-form-item>
					<el-form-item label="提交人" prop="name"><el-button type="success" size="mini">打工仔A</el-button></el-input></el-form-item>
					<el-form-item label="提交内容" prop="name"><el-input v-model="form.desc" size="mini" style="width: 100%;"></el-input></el-form-item>
					<el-form-item label="创建时间" prop="name"><el-input v-model="form.time" size="mini" style="width: 100%;"></el-input></el-form-item>
				</el-form>
			</div>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit(tableData)">确 定</el-button>
			</div>
		</el-dialog>
	</div>
	
</template>

<script>
	import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
	import common from '@/common/mixins/common.js'; // 引入 全局共公样式
	import { mapState } from 'vuex'; // 引入 全局 公共数据
	export default {
		mixins: [common], // 引入mixins里的common.js
		inject: ['layout'], // 依赖注入
		// 引入注册
		components: {
			buttonSearch
		},
		data() {
			return {
				preUrl: "goods", // api

				tabIndex: 0,
				form: {
					id: 789,
					name: "恒大集团",
					phone:'1256545645',
					zjphone:'020-656846',
					lxr:'打工仔A',
					email:'45848@qq.com',
					city:'广东省-广州市-天河区',
					xxdz:'广东省广州市天河区体育西地铁出口左转60000米',
					desc:'有钱任性',
					state:1,
					xssl:99,
					xstime:'2022-08-22 19:55:21',
					time:'2022-08-22 19:55:21',
					gz:'打工仔F',
					zr:'打工仔O',
					user:'打工仔A',
					gxsw:'打工仔V'
				},
				tableData: [],
				cateOptions: [],
				createModel: false,
				value:'更多',
			}
		},
		filters: {
			tree(item) {
				if (item.level == 0) {
					return item.name
				}
				let str = ''
				for (let i = 0; i < item.level; i++) {
					str += i == 0 ? '|--' : '--'
				}
				return str + ' ' + item.name;
			}
		},
		// 计算属性
		computed: {
			// 引入store-modules的user模块里面的user(存储用户相关的数据)
			...mapState({
				user: state => state.user.user,
				navBar: state => state.menu.navBar
			}),
			params() {
				let str = ''
				for (let key in this.form) {
					let val = this.form[key]
					if (val) {
						str += `&${key}=${this.form[key]}`
					}
				}
				return str
			}
		},
		// 生命周期，调用__getData生成的数据
		created() {

		},
		// 生命周期监听页面
		methods: {
			gotos(e){
				console.log(e)
				this.$router.push({
					name: e
				})
			},
			// 调转基础设置、商品规格、商品属性、媒体设置、商品详情页面
			navigate(name, id) {
				this.$router.push({
					name,
					params: { id }
				})
			},
			// 获取请求列表分页url
			getListUrl() {
				return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&tab=${this.tab}${this.params}`
			},
			// 获取列表 可修改
			getListResult(e) {
				console.log(this.user);
				this.tableData = e.list
				this.cateOptions = e.cates
			},
			// 上下架
			changeStatus(item) {
				item.status = item.status === 1 ? 0 : 1
			},
			// 清空筛选条件
			clearSearch() {
				this.form = {
					title: "",
					category_id: ""
				}
			},
			// 搜索事件
			searchEvent(e = false) {
				// 简单搜索
				if (typeof e === 'string') {
					this.form.title = e
				}
				// 高级搜索
				this.getList()
			},
			// 删除商品/恢复商品
			doEvent(key) {
				if (this.ids.length === 0) {
					return this.$message({
						type: "error",
						message: "请选择要操作的商品"
					})
				}
				this.showLoading()
				this.axios.post('/admin/goods/' + key, { //删除商品/恢复商品api（restore、destroy区别 删除/回复）
					ids: this.ids
				}, {
					token: true
				}).then(res => {
					this.$message({
						type: "success",
						message: "操作成功"
					})
					this.getList()
					this.hideLoading()
				}).catch(err => {
					this.hideLoading()
				})
			},
			// 上下架
			changeStatus(status) {
				if (this.ids.length === 0) {
					return this.$message({
						type: "error",
						message: "请选择要操作的商品"
					})
				}
				this.showLoading()
				this.axios.post('/admin/goods/changestatus', { //商品上下架api
					ids: this.ids,
					status
				}, {
					token: true
				}).then(res => {
					this.$message({
						type: "success",
						message: "操作成功"
					})
					this.getList()
					this.hideLoading()
				}).catch(err => {
					this.hideLoading()
				})
			},
			// 审核商品 ischeck审核 1同意 2拒绝
			checkGoods(item, ischeck) {
				this.layout.showLoading()
				this.axios.post('/admin/goods/' + item.id + '/check', { //审核商品 api
					ischeck
				}, {
					token: true
				}).then(res => {
					this.getList()
					this.$message({
						type: "success",
						message: "操作成功"
					})
					this.layout.hideLoading()
				}).catch(err => {
					this.layout.hideLoading()
				})
			},
			openModel(e = false) {
				console.log(e);
				this.tableData[e.row.id - 1] = {
					id: e.row.id,
					create_time: '2022-08-19 14:40:20',
					name: e.row.name,
					class: e.row.class,
					state: 1,
					user: '你好啊'
				};
				// 打开dialog
				this.createModel = true;
			},
		},
	}
</script>

<style>
</style>
